import { Injectable } from '@angular/core';
import { ChartDataSets, ChartOptions } from "chart.js";
import { MultiDataSet, Label, Color, Colors, BaseChartDirective } from "ng2-charts";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import * as pluginAnnotations from "chartjs-plugin-annotation";
import * as _moment from "moment";

const moment = (_moment as any).default ? (_moment as any).default : _moment;

@Injectable({
  providedIn: 'root'
})
export class BankPaymentsAmountService {


  public months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
  ];

  public days = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];

  public fakeData1 = [1965, 5945, 8067, 8187, 5689, 5509, 4088];
  public fakeData2 = [2845, 4842, 4056, 1987, 8688, 2798, 9021];

  public lineChartData: ChartDataSets[] = [
    { data: [], label: " Montos" }
  ];

  public lineChartLabels: Label[] = [];
  public lineChartOptions: ChartOptions & { annotation: any } = {
    responsive: true,
    maintainAspectRatio: true,
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          // console.log('tooltip', tooltipItem, data);
          const { value } = tooltipItem;
          if (parseInt(value) >= 1000) {
            return "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          } else {
            return "$" + value;
          }
        },
      },
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "transparent",
            lineWidth: 0.1,
            drawOnChartArea: true,
          },
          ticks: {
            display: true,
            beginAtZero: true,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: "transparent",
            lineWidth: 5,
            drawOnChartArea: true,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
        },
        {
          id: "y-axis-0",
          position: "left",
          gridLines: {
            color: "rgba(216,216,216,.4)",
            borderDash: [4],
          },
          ticks: {
            beginAtZero: true,
            callback: function (value: any, index: any, values: any) {
              if (parseInt(value) >= 1000) {
                return (
                  "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                );
              } else {
                return "$" + value;
              }
            },
          },
        },
      ],
    },
    annotation: {
      annotations: [
        {
          type: "line",
          mode: "vertical",
          scaleID: "x-axis-0",
          value: "Febrero",
          borderColor: "green",
          borderWidth: 2,
          label: {
            enabled: true,
            fontColor: "white",
            content: "Afiliación",
          },
        },
      ],
    },
    plugins: {
      datalabels: {
      /* formatter: (value, ctx) => {
         let sum = 0;
         const dataArr: any = this.lineChartData[0].data;
         dataArr.map((data: any) => {
           sum += data;
         });
         const percentage: any = ((value * 100) / sum).toFixed(2) + "%";
         return percentage;
       },

       render: "percentage",*/
       color: "transparent",
       anchor: "end",
       align: "left",
       font: {
         size: 12
       }
     }
   },
    legend: {
      display: true,
      position: "top",
      labels: {
        fontColor: "#333",
        usePointStyle: true,
        padding: 20,
      },
    },
  };

  public color1 = 'rgba(4, 169, 141,1)';
  public color2 = 'rgba(184, 207, 72,1)';

  public lineChartColors: Color[] = [
    {
      // 1
      backgroundColor: "rgba(4, 169, 141,0.1)",
      borderColor: "rgba(17, 221, 95, 1)",
      borderWidth: 0.5,
      pointBackgroundColor: this.color1,
      pointBorderColor: this.color1,
      pointHoverBackgroundColor: "rgba(28, 176, 211, 1)",
      pointHoverBorderColor: "rgba(148,159,177,0.8)",
      pointBorderWidth: 2,
    },
    {
      // 2
      backgroundColor: "rgba(184, 207, 72,0.2)",
      borderColor: "rgba(184, 207, 72,1)",
      borderWidth: 0.5,
      pointBackgroundColor: this.color2,
      pointBorderColor: this.color2,
      pointHoverBackgroundColor: "rgba(28, 176, 211, 1)",
      pointHoverBorderColor: "rgba(148,159,177,0.8)",
      pointBorderWidth: 2,
    },
  ];

  constructor () {

  }

  public setLabel(label: string) {
    this.lineChartData[0].label = label;
  }
}

